module.exports = __webpack_public_path__ + "static/sport/bgi-btn-a.b97bc79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-btn-a.png
// module id = JGdw
// module chunks = 0